<script>
  import { router } from "@inertiajs/svelte";
  import AddSocialForm from "./AddSocialForm.svelte";

  let { socialProfiles, loadSocialProfiles } = $props();

  let showAddProfileForm = $state(false);

  let toggleAddProfileForm = () => {
    showAddProfileForm = !showAddProfileForm;
  };

  let goToSocialProfile = (id) => {
    router.get(`/dashboard/social_profiles/${id}`);
  };
</script>

<div class="flex items-center justify-between mb-4">
  <h2 class="text-xl font-semibold text-gray-800">Social Profiles</h2>
  {#if !showAddProfileForm}
    <button
      onclick={toggleAddProfileForm}
      class="cursor-pointer px-3 py-1.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors flex items-center space-x-1.5 shadow-sm text-sm font-medium focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
      <svg
        class="w-3.5 h-3.5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
      </svg>
      <span>Add Profile</span>
    </button>
  {/if}
</div>

{#if showAddProfileForm}
  <div
    class="bg-white rounded-lg p-6 border border-indigo-200 mb-6 shadow-md relative">
    <button
      onclick={toggleAddProfileForm}
      class="absolute top-3 right-3 text-gray-500 hover:text-indigo-700 transition-colors p-1.5 rounded-full hover:bg-gray-100"
      aria-label="Close form">
      <svg
        class="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </button>

    <div class="pt-2">
      <AddSocialForm {loadSocialProfiles} />
    </div>
  </div>
{/if}

<div class="space-y-4">
  {#each socialProfiles as sp}
    <div
      class="p-4 border border-gray-100 rounded-lg hover:border-blue-200 transition-colors">
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          {#if sp.profile && sp.profile.profile_picture_url && sp.profile.profile_picture_url.includes("socialstrack")}
            <img
              src={sp.profile.profile_picture_url}
              alt="{sp.username}'s profile picture"
              class="w-10 h-10 rounded-full object-cover rounded-lg mr-3" />
          {:else}
            <div
              class="p-2 rounded-lg mr-3"
              class:bg-pink-100={sp.platform === "instagram"}
              class:bg-blue-100={sp.platform === "tiktok"}>
              {#if sp.platform === "instagram"}
                <svg
                  class="w-5 h-5 text-pink-600"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0z"
                  ></path>
                  <path
                    d="M12 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8z"
                  ></path>
                  <circle cx="18.406" cy="5.594" r="1.44"></circle>
                </svg>
              {:else if sp.platform === "tiktok"}
                <svg
                  class="w-5 h-5 text-blue-600"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"
                  ></path>
                </svg>
              {/if}
            </div>
          {/if}
          <div>
            <h3 class="font-medium text-gray-800">{sp.username}</h3>
            <p class="text-xs text-gray-500 capitalize">
              {sp.platform}
            </p>
          </div>
        </div>
        <button
          class="cursor-pointer px-3 py-1.5 text-sm font-medium bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 transition-colors flex items-center gap-1 border border-blue-100"
          onclick={() => goToSocialProfile(sp.id)}>
          <svg
            class="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            ></path>
          </svg>
          View Details
        </button>
      </div>
    </div>
  {/each}
</div>
